// src/stores/notifications.js
import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from '@/axios';

export const useNotificationsStore = defineStore('notifications', () => {
  // Lista de notificações
  const notifications = ref([]);

  // Atualiza as notificações no estado
  function setNotifications(data) {
    notifications.value = data;
  }

  // Busca todas as notificações da API
  async function fetchNotifications() {
    try {
      const response = await axios.get('/notifications');
      // se vier como { notifications: [...] }
      const list = Array.isArray(response.data)
        ? response.data
        : response.data.notifications ?? [];
      setNotifications(list);
    } catch (err) {
      console.error('Falha ao buscar notificações:', err);
    }
  }
  

  // Marca notificações específicas como lidas
  async function markAsRead(ids) {
    if (!ids.length) return;
    try {
      await axios.post('/notifications/read', { notificationIds: ids });
      // Atualiza localmente sem refetch para melhor responsividade
      notifications.value = notifications.value.map(n =>
        ids.includes(n.id) ? { ...n, is_read: 1 } : n
      );
    } catch (err) {
      console.error('Falha ao marcar notificações como lidas:', err);
    }
  }

  // Marca todas as notificações como lidas
  async function markAllAsRead() {
    const allIds = notifications.value.map(n => n.id);
    await markAsRead(allIds);
  }

  return {
    notifications,
    setNotifications,
    fetchNotifications,
    markAsRead,
    markAllAsRead
  };
});
